import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import CloseLine from '@/assets/svgs/close-line.svg'
import { StyledActionButton } from '@/components/Buttons.tsx'
import { FormSubmit } from '@/components/templates/Form.tsx'
import { FullScreenContainer } from '@/components/templates/ScreenLayout.tsx'
import { BodyM, Header2 } from '@/components/Text.tsx'

const ButtonWrapper = styled(FormSubmit)`
  position: absolute;
  bottom: 32px;
  width: calc(100% - 40px);
`

const CrossIcon = styled.div`
  width: 48px;
  height: 48px;
  display: flex;
  align-self: center;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background-color: ${({ theme }) => theme.colors.common.alert};
`

const ErrorHeader = styled(Header2)`
  margin: 20px 0;
`

export const Error = ({
  error,
  onBack,
  onReset,
  phoneNumber,
}: {
  error?: string
  onReset: () => void
  onBack: () => void
  phoneNumber?: string
}) => {
  const { t } = useTranslation('translation', {
    keyPrefix: 'errorScreen',
  })

  return (
    <FullScreenContainer align="center">
      <CrossIcon>
        <img src={CloseLine} alt="error-icon" />
      </CrossIcon>
      <ErrorHeader>{t('header')}</ErrorHeader>
      {error && <BodyM>{t(`messages.${error}`)}</BodyM>}
      <ButtonWrapper>
        {phoneNumber && (
          <StyledActionButton
            variant="Primary"
            as="a"
            href={`tel:${phoneNumber}`}
          >
            {t('actions.callUs')}
          </StyledActionButton>
        )}
        <StyledActionButton variant="Primary" onClick={onReset}>
          {t('actions.createNewAppointment')}
        </StyledActionButton>
        <StyledActionButton variant="Secondary" onClick={onBack}>
          {t('actions.goBack')}
        </StyledActionButton>
      </ButtonWrapper>
    </FullScreenContainer>
  )
}
